// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import * as DmsCommon from '../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { GlobalEvent, GlobalState } from './GlobalContext'
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import IconButton from '@mui/material/IconButton';
import SelFolderDialog from './SelFolderDialog';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import DatePicker from '@mui/lab/DatePicker';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useForm, Controller } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import dayjs from 'dayjs';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';

import SearchCriteriaAddDialog from './SearchCriteriaAddDialog';

export const FIELD_FOLDER = { "value": "Folder", "label": "Folder" };
export const FIELD_DOC_DATE = { "value": "DocDate", "label": "Doc Date" };
export const FIELD_DOC_TYPE = { "value": "DocType", "label": "Doc Type" };
export const FIELD_SUBJECT = { "value": "Subject", "label": "Subject" };
export const FIELD_SENDER = { "value": "Sender", "label": "Sender" };
export const FIELD_COMPANY = { "value": "Company", "label": "Company / Department" };
export const FIELD_RECIPIENT = { "value": "Recipient", "label": "Recipient" };
export const FIELD_DOC_REF = { "value": "DocRef", "label": "Ref No" };
export const FIELD_OUR_REF = { "value": "OurRef", "label": "Our Ref No" };
export const FIELD_RECEIVE_DATE = { "value": "ReceiveDate", "label": "Receive Date" };
export const FIELD_FILE_LOC = { "value": "FileLoc", "label": "File Loc" };
export const FIELD_KEYWORD = { "value": "Keywords", "label": "Keywords" };
export const FIELD_UPD_DATE = { "value": "UpdDate", "label": "Last Rev Upload Date" };
export const FIELD_UPD_BY = { "value": "UpdBy", "label": "Last Rev Upload By" };

export const SEARCH_FIELD_LIST = [
  FIELD_FOLDER,
  FIELD_DOC_DATE,
  FIELD_DOC_TYPE,
  FIELD_SUBJECT,
  FIELD_SENDER,
  FIELD_COMPANY,
  FIELD_RECIPIENT,
  FIELD_DOC_REF,
  FIELD_OUR_REF,
  FIELD_RECEIVE_DATE,
  FIELD_FILE_LOC,
  FIELD_KEYWORD,
  FIELD_UPD_DATE,
  FIELD_UPD_BY
];

export const OPERATORS_STR = ['=', '<>', 'like'];
export const OPERATORS_DATE = ['=', '<>', '>', '<', 'between'];
export const OPERATORS_BOOL = ['=', '<>'];
export const OPERATORS_ALL = ['=', '<>', '>', '<', 'between', 'like'];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function SearchDialogContent(props) {

  const theme = useTheme();

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const { sysID, onSearch } = props;

  const advSearchGridRef = React.useRef();

  const folders = props.folders || [];
  // const folderID = props.folderID || DmsCommon.ALL_FOLDER_ID;

  const [openFolderDialog, setOpenFolderDialog] = useState(false);


  const [selFolderID, setSelFolderID] = useState(DmsCommon.ALL_FOLDER_ID);

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }

  const [docTypes, setDocTypes] = useState([]);

  useEffect(() => {

    if (sysID != null && sysID !== "") {
      const aFunc = async () => {
        try {
          const vDocTypes = await DmsService.getDocTypesPromise(gState.sessionID, sysID);
          setDocTypes(vDocTypes);
        } catch (e) {
          onCatchPromiseError(e);
        }
      }
      aFunc();


      // const vFolder = folders.find(f => f.id === folderID);
      // if (vFolder) {
      //   // console.log("SearchDialogContent vFolder", vFolder);

      //   setValue("folderID", vFolder.id, { shouldDirty: true });
      //   setValue("folderPath", vFolder.FolderPath, { shouldDirty: true });
      // }

    }
  }, [sysID])



  const handleSelectFolderID = (aFolderID) => {

    // console.log("aFolderID", aFolderID);



    setOpenFolderDialog(false);

    let vFolderPath = "";
    if (aFolderID == DmsCommon.ALL_FOLDER_ID) {
      vFolderPath = DmsCommon.ALL_FOLDER_NAME;
    } else if (aFolderID == DmsCommon.ALL_FOLDER_ID) {
      vFolderPath = DmsCommon.PERSONAL_FOLDER_NAME;
    } else {
      const vSelFolder = folders.find(f => f.id === aFolderID);
      if (vSelFolder) {
        vFolderPath = vSelFolder.FolderPath;
      }
    }

    setSelFolderID(aFolderID);

    setValue("folderID", aFolderID, { shouldDirty: true });
    setValue("folderPath", vFolderPath, { shouldDirty: true });

  }

  const [option, setOption] = useState('1');
  const handleOptionChange = (event) => {
    setOption(event.target.value);
  }


  // React Hook the form
  const defValues = {
    searchText: "",
    useElastic: true, // Default to use Elastic Search
    docDateFrom: null,
    docDateTo: null,
    folderID: DmsCommon.ALL_FOLDER_ID,
    folderPath: DmsCommon.ALL_FOLDER_NAME,
  };
  const { control, handleSubmit, setValue, reset, watch } = useForm({
    defaultValues: defValues,
  });

  const watchSearchText = watch("searchText");
  const watchDocDateFrom = watch("docDateFrom");
  const watchDocDateTo = watch("docDateTo");
  const watchFolderID = watch("folderID");
  const watchUseElastic = watch("useElastic");

  const handleResetClick = () => {
    reset(defValues);
    setOption('1')

    setSelectedCriteria(null);
    setAdvSearchCriteria([]);
  }


  // const onSubmit = data => {
  //   console.log(data);

  //   if (tabValue === 0) {
  //     let vSearchFolderID = DmsCommon.ALL_FOLDER_ID;
  //     if (option == '2') {
  //       vSearchFolderID = data.folderID;
  //     }
  //     // console.log('vSearchFolderID', vSearchFolderID);

  //     const docDateFrom = data.docDateFrom?.format(DmsCommon.ISO_DATETIME_FORMAT) || "";
  //     const docDateTo = data.docDateTo?.format(DmsCommon.ISO_DATETIME_FORMAT) || "";


  //     onSearch && onSearch(vSearchFolderID, data.searchText, data.useElastic, docDateFrom, docDateTo);

  //   } else if (tabValue === 1) {
  //     // console.log('advSearchCriteria', advSearchCriteria);

  //     onSearch && onSearch(null, null, null, null, advSearchCriteria);
  //   }


  // }

  const onSubmitClick = () => {

    if (tabValue === 0) {
      let vSearchFolderID = DmsCommon.ALL_FOLDER_ID;
      if (option == '2') {
        vSearchFolderID = watchFolderID;
      }
      const docDateFrom = watchDocDateFrom?.format(DmsCommon.ISO_DATETIME_FORMAT) || "";
      const docDateTo = watchDocDateTo?.format(DmsCommon.ISO_DATETIME_FORMAT) || "";


      onSearch && onSearch(vSearchFolderID, watchSearchText, watchUseElastic, docDateFrom, docDateTo);

    } else if (tabValue === 1) {
      // console.log('advSearchCriteria', advSearchCriteria);

      onSearch && onSearch(null, null, null, null, advSearchCriteria);
    }


  }

  const [openCriteriaDialog, setOpenCriteriaDialog] = useState(false);
  const [isEditCriteria, setIsEditCriteria] = useState(false);

  const handleAddClick = () => {
    setIsEditCriteria(false);
    setOpenCriteriaDialog(true);
  }

  const handleEditClick = () => {
    // console.log('handleEditClick', selectedCriteria);
    setIsEditCriteria(true);
    setOpenCriteriaDialog(true);

  }

  const handleDeleteClick = () => {

    // console.log('handleDeleteClick', selectedCriteria);
    if (!selectedCriteria) return;

    const vNewCriteria = advSearchCriteria.filter(c => c.id !== selectedCriteria.id);
    // console.log(' handleCriteriaAddOk ~ vNewCriteria:', vNewCriteria);
    const vMassagedCriteria = massageCriteria(vNewCriteria);
    // console.log(' handleCriteriaAddOk ~ vMassagedCriteria:', vMassagedCriteria);
    setAdvSearchCriteria(vMassagedCriteria);

    setSelectedCriteria(null);
    advSearchGridRef.current.deselectAll();

  }

  const massageCriteria = (aCriteriaData) => {

    const vLastIdx = aCriteriaData.length - 1;

    const rstData = aCriteriaData.map((aData, idx) => {

      let vCriteriaStr = '';

      // const vValueDisplay1 = getDisplayValue(aData.fieldName, aData.value1);
      // const vValueDisplay2 = getDisplayValue(aData.fieldName, aData.value2);

      vCriteriaStr = `[${aData.fieldDisplay}] ${aData.operator} '${aData.valueDisplay1}'`;
      if (aData.operator === 'between') {
        vCriteriaStr += ` and '${aData.valueDisplay2}'`;
      }

      if (idx < vLastIdx) {
        const vNextItem = aCriteriaData[idx + 1];

        if (vNextItem.connect === 'and') {
          vCriteriaStr += ' ,'
        } else if (vNextItem.connect === 'or') {
          vCriteriaStr += ' OR'
        }

      }

      return {
        ...aData,
        id: idx,
        criteria: vCriteriaStr,
      };
    });

    return rstData;

  }

  const handleCriteriaAddOk = (aData) => {
    // console.log('handleCriteriaAddOk', aData);
    setOpenCriteriaDialog(false);

    let vNewCriteria = [];
    if (isEditCriteria) {
      vNewCriteria = advSearchCriteria.map(c => {
        if (c.id === aData.id) {
          return aData
        } else {
          return c
        }
      })


    } else {
      if (selectedCriteria) {
        vNewCriteria = [...advSearchCriteria];

        // Add new criteria under selected item if exists
        const selectIdx = vNewCriteria.findIndex(c => c.id === selectedCriteria.id);
        if (selectIdx > -1) {
          vNewCriteria.splice(selectIdx + 1, 0, aData);
        } else {
          vNewCriteria.push(aData);
        }
      } else {
        vNewCriteria = [...advSearchCriteria, aData];
      }

    }
    // console.log(' handleCriteriaAddOk ~ vNewCriteria:', vNewCriteria);
    const vMassagedCriteria = massageCriteria(vNewCriteria);
    // console.log(' handleCriteriaAddOk ~ vMassagedCriteria:', vMassagedCriteria);
    setAdvSearchCriteria(vMassagedCriteria);

    if (isEditCriteria) {
      const rowNode = advSearchGridRef.current.getRowNode(aData.id);
      // console.log(' handleCriteriaAddOk ~ rowNode:', rowNode);
      if (rowNode) {
        const editData = vNewCriteria.find(c => c.id === aData.id);
        setSelectedCriteria(editData);

        rowNode.setSelected(true);
      } else {
        setSelectedCriteria(null);

        advSearchGridRef.current.deselectAll();
      }
    }


  }

  const handleSearchTextKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // prevent newline (important for multiline)

      const currentValue = e.target.value;
      // console.log("Enter pressed:", currentValue);

      onSubmitClick();
    }
  };

  // const [isAllFolders, setIsAllFolders] = useState(true);

  // const handleAllFolderChange = (event) => {
  //   setIsAllFolders(event.target.checked);
  // }

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const [advSearchCriteria, setAdvSearchCriteria] = useState([]);

  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  const columnDefs = [
    // {
    //   field: 'fieldName', headerName: "Field", cellStyle: cellStyle, sortable: false,
    //   flex: "1"
    // },
    // {
    //   field: 'fieldDisplay', headerName: "FieldDisplay", cellStyle: cellStyle, sortable: false,
    //   flex: "1"
    // },
    {
      field: 'criteria', headerName: "Find documents that match these criteria:", cellStyle: cellStyle, sortable: false,
      flex: "1"
    },
  ];

  const [selectedCriteria, setSelectedCriteria] = useState(null);

  const onSelectionChanged = (params) => {
    let nodes = params.api.getSelectedNodes();

    let selRecs = nodes.map(item => {
      return item.data
    });


    if (selRecs.length > 0) {
      setSelectedCriteria(selRecs[0])
    } else {
      setSelectedCriteria(null)
    }

  }

  let disableSerach = false;
  if (tabValue === 0) {
    if (watchSearchText === '' && watchDocDateFrom === null && watchDocDateTo === null) {
      disableSerach = true;
    }
  } else if (tabValue === 1) {
    if (advSearchCriteria.length === 0) { disableSerach = true; }
  }

  return (
    <Box component="form"
    // onSubmit={handleSubmit(onSubmit)}
    >
      <SelFolderDialog
        open={openFolderDialog}
        onClose={() => setOpenFolderDialog(false)}
        folders={folders}
        iniFolderID={selFolderID}
        disableAllFolder
        disablePersonalFolder
        disablePhyLocFolder
        onSelectFolderID={handleSelectFolderID}

      />

      <Box
        sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: "200px" }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}

          // indicatorColor="secondary"
          // textColor="inherit"
          variant="scrollable"
          // scrollButtons="auto"
          orientation="vertical"
          sx={{ borderRight: 1, borderColor: 'divider', width: '120px' }}
        >
          <Tab label="Quick " {...a11yProps(0)} />
          <Tab label="Advance" {...a11yProps(1)} />

        </Tabs>

        <TabPanel value={tabValue} index={0} dir={theme.direction}>

          <Box sx={{ pt: 1, width: "700px" }} >




            <FormGroup sx={{ mt: 0, px: 2 }} >
              {/* <FormControlLabel control={
            <Checkbox
              checked={isAllFolders}
              onChange={handleAllFolderChange}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
            label="All Folders" /> */}

              <Grid container spacing={{ xs: 1 }}  >

                <Grid item xs={12} sm={6}>
                  <Controller
                    name="searchText"
                    control={control}
                    render={({ field }) =>
                      <TextField
                        {...field}
                        autoFocus
                        InputLabelProps={{ shrink: true, }}
                        fullWidth
                        // id="standard-search"
                        label="Search Text"
                        type="search"

                        onKeyDown={handleSearchTextKeyDown}
                        variant="standard"
                      />

                    }
                  />

                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="useElastic"
                    control={control}
                    render={({ field }) =>
                      <FormControl component="fieldset">
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                {...field}
                                checked={field.value}
                                onChange={(e) => field.onChange(e.target.checked)}
                              />}
                            label="Content Search"
                            {...field}
                          />
                        </FormGroup>
                      </FormControl>
                    }
                  />
                </Grid>



                <Grid item xs={12} sm={6}>
                  <Controller
                    name="docDateFrom"
                    control={control}
                    render={({ field }) =>
                      <DatePicker
                        label="Document Date (from)"
                        type="date"
                        inputFormat={DmsCommon.SHORT_DATE_FORMAT}
                        {...field}
                        renderInput={(params) => <TextField
                          variant="standard"
                          fullWidth
                          {...params}
                          InputLabelProps={{ shrink: true, }}
                        />}
                      />}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>

                  <Controller
                    name="docDateTo"
                    control={control}
                    render={({ field }) =>
                      <DatePicker
                        label="Document Date (to)"
                        type="date"
                        inputFormat={DmsCommon.SHORT_DATE_FORMAT}
                        {...field}
                        renderInput={(params) => <TextField
                          variant="standard"
                          fullWidth
                          {...params}
                          InputLabelProps={{ shrink: true, }}
                        />}
                      />}
                  />
                </Grid>
                <Grid item xs={12} >
                  <RadioGroup
                    aria-labelledby="search-option-radio-buttons-group"
                    name="search-option-radio-buttons-group"
                    value={option}
                    row
                    onChange={handleOptionChange}
                  >
                    <FormControlLabel value="1" control={<Radio />} label="All Folders" />
                    <FormControlLabel value="2" control={<Radio />} label="Select Folder" />
                    <Controller
                      name="folderPath"
                      control={control}
                      render={({ field }) =>
                        <TextField
                          label=""
                          variant="standard"
                          // required
                          disabled={option == '1'}
                          fullWidth
                          {...field}
                          InputLabelProps={{ shrink: true, }}

                          InputProps={{
                            readOnly: true,
                            endAdornment:
                              <InputAdornment position="end">
                                <IconButton
                                  disabled={option == '1'}
                                  onClick={() => { setOpenFolderDialog(true) }}
                                  onMouseDown={() => event.preventDefault()}
                                  edge="end"
                                >
                                  <FolderOpenIcon />
                                </IconButton>
                              </InputAdornment>
                          }}
                        />}
                    />
                  </RadioGroup>
                </Grid>
              </Grid>



            </FormGroup>



          </Box>

        </TabPanel>

        <TabPanel value={tabValue} index={1} dir={theme.direction}>
          <SearchCriteriaAddDialog
            open={openCriteriaDialog}
            onClose={() => setOpenCriteriaDialog(false)}
            isEdit={isEditCriteria}
            criteriaData={selectedCriteria}
            onOk={handleCriteriaAddOk}
            docTypes={docTypes}
            folders={folders}
          />

          <Box sx={{ display: 'flex', height: "200px", width: "700px", flexDirection: 'column' }} >
            <Box sx={{ px: 1 }} >
              <Button startIcon={<AddIcon />} onClick={handleAddClick} >
                Add
              </Button>
              <Button startIcon={<EditIcon />} onClick={handleEditClick} disabled={!(selectedCriteria)}  >
                Edit
              </Button>
              <Button startIcon={<DeleteIcon />} onClick={handleDeleteClick} disabled={!(selectedCriteria)} >
                Delete
              </Button>
            </Box>
            <div className="ag-theme-material" style={{ width: '100%', height: '100%', bgcolor: 'yellow' }}>
              <AgGridReact
                ref={advSearchGridRef}

                rowData={advSearchCriteria}

                defaultColDef={{
                  width: 100,
                  resizable: true,
                  sortable: true,
                  suppressMovable: true,
                }}
                columnDefs={columnDefs}
                headerHeight={40}

                suppressNoRowsOverlay

                rowSelection="single"
                getRowId={(params) => params.data.id}
                onSelectionChanged={onSelectionChanged}

                onGridReady={(params) => advSearchGridRef.current = params.api}
              >


              </AgGridReact>

            </div>
          </Box>


        </TabPanel>

      </Box>



      <Box sx={{ display: 'flex', mt: 2, ml: 2 }}>
        <Button onClick={handleResetClick}>Reset</Button>
        <Button
          // type="submit"
          variant="contained"
          startIcon={<SearchIcon />}
          disabled={disableSerach}
          onClick={onSubmitClick}
        >
          Search
        </Button>

      </Box>
    </Box>
  );
}

SearchDialogContent.propTypes = {
  sysID: PropTypes.string,
  onSearch: PropTypes.func,
  // folderID: PropTypes.number,
  folders: PropTypes.array,
};

export default SearchDialogContent